import React, { useEffect, useState } from "react";
import "../../style/LatestVideo/index.scss";
import { DarkModeState ,showsData} from "../../Jotai/index";
import { useAtom } from "jotai";

// Decode common HTML entities in titles returned by YouTube API
const decodeHtml = (s) => {
  if (!s) return "";
  return String(s)
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;|&#039;|&apos;/g, "'");
};

const LatestVideo = ({id}) => {
  const [darkMode] = useAtom(DarkModeState);
  const [shows] = useAtom(showsData);
  const isLocalhost = typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '::1'
  );

  // YouTube API state
  const [ytVideos, setYtVideos] = useState([]); // [{ id, title, publishedAt }]
  const [ytLoading, setYtLoading] = useState(false);
  const [ytError, setYtError] = useState("");

  // Default player source (fallback to first item in shows list)
  const defaultSrc = (Array.isArray(shows) && shows[0]?.show) || "";
  const [playData, setplayData] = useState(defaultSrc);

  // Fetch latest 5 videos from 22WestTV (skip on localhost)
  useEffect(() => {
    if (isLocalhost) return; // use fallback list while developing locally

    const API_KEY = process.env.REACT_APP_YT_API_KEY;
    if (!API_KEY) {
      setYtError("Missing YouTube API key");
      return;
    }

    const CACHE_KEY = 'yt_22westtv_latest5';
    const CACHE_TS = 'yt_22westtv_latest5_ts';
    const TTL_MS = 10 * 60 * 1000; // 10 minutes
    const now = Date.now();
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      const ts = parseInt(localStorage.getItem(CACHE_TS) || '0', 10);
      if (raw && ts && (now - ts) < TTL_MS) {
        const cached = JSON.parse(raw);
        if (Array.isArray(cached) && cached.length) {
          setYtVideos(cached);
          setplayData(`https://www.youtube.com/embed/${cached[0].id}?rel=0&modestbranding=1&color=white`);
          return;
        }
      }
    } catch {}

    let abort = false;
    const controller = new AbortController();
    const signal = controller.signal;
    setYtLoading(true);
    setYtError("");

    const YT_BASE = 'https://www.googleapis.com/youtube/v3';
    const handle = '@22WestTV';

    const fetchJson = async (url) => {
      const res = await fetch(url, { signal });
      if (!res.ok) {
        const txt = await res.text().catch(() => '');
        throw new Error(`${res.status} ${txt}`);
      }
      return res.json();
    };

    const resolveChannelId = async () => {
      // Try handle first
      try {
        const u1 = `${YT_BASE}/channels?part=id&forHandle=${encodeURIComponent(handle)}&key=${API_KEY}`;
        const j1 = await fetchJson(u1);
        const id = j1?.items?.[0]?.id;
        if (id) return id;
      } catch {}
      // Fallback: search channel by name
      const u2 = `${YT_BASE}/search?part=snippet&type=channel&maxResults=1&q=${encodeURIComponent('22WestTV')}&key=${API_KEY}`;
      const j2 = await fetchJson(u2);
      return j2?.items?.[0]?.id?.channelId || '';
    };

    const run = async () => {
      try {
        const channelId = await resolveChannelId();
        if (!channelId) throw new Error('Channel not found');
        const u3 = `${YT_BASE}/search?part=snippet&channelId=${encodeURIComponent(channelId)}&maxResults=5&order=date&type=video&key=${API_KEY}`;
        const j3 = await fetchJson(u3);
        const items = (j3?.items || []).map((it) => ({
          id: it?.id?.videoId,
          title: it?.snippet?.title || 'Untitled',
          publishedAt: it?.snippet?.publishedAt || '',
        })).filter(v => v.id);
        if (!items.length) throw new Error('No videos found');
        if (abort) return;
        setYtVideos(items);
        setplayData(`https://www.youtube.com/embed/${items[0].id}?rel=0&modestbranding=1&color=white`);
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify(items));
          localStorage.setItem(CACHE_TS, String(Date.now()));
        } catch {}
      } catch (e) {
        if (abort) return;
        setYtError(e?.message || 'Failed to load latest videos');
      } finally {
        if (!abort) setYtLoading(false);
      }
    };

    run();
    return () => { abort = true; controller.abort(); };
  }, [isLocalhost]);

  // Build the list to render (API or fallback)
  const listItems = (!isLocalhost && ytVideos.length)
    ? ytVideos.map(v => ({
        src: `https://www.youtube.com/embed/${v.id}?rel=0&modestbranding=1&color=white`,
        title: decodeHtml(v.title),
        date: v.publishedAt ? new Date(v.publishedAt).toLocaleDateString() : '',
      }))
    : (Array.isArray(shows) ? shows.slice(0, 5).map((s) => ({
        src: s.show,
        title: decodeHtml(s.title || s.name || 'Untitled'),
        date: s.date_val || '',
      })) : []);

  return (
    <>
      <div id={id} className="LatestVideo">
        <div
          className={darkMode ? "LatestVideoMain darkmode" : "LatestVideoMain"}
        >
          <div className="LatestVideoTitle">Latest Programs</div>
          <div className="LatestVideoVideoSec">
            <div className="LatestVideoVideoSecleft">
              {listItems.slice(0,5).map((data, index) => {
                return (
                  <>
                    <div
                    onClick={()=>{setplayData(data.src)}}
                      className={
                        darkMode
                          ? "LatestVideoCard"
                          : "LatestVideoCard wbgcolor"
                      }
                      key={index}
                    >
                      <div className="LatestVideoCard_img">
                        <iframe
                          src={data.src}
                          onClick={() => {}}
                          title="YouTube video player"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                          className="LatestVideoVideoSecRight_imgVideo"
                        />
                      </div>
                      <div className="LatestVideoCard_data">
                        <div className="LatestVideoCard_data_title">
                          {data.title}
                        </div>
                        <div className="LatestVideoCard_data_name">
                          {/* Secondary text can be used for channel or series if available */}
                        </div>
                        <div className="LatestVideoCard_data_Date">
                          {data.date}
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
            <div className="LatestVideoVideoSecRight">
              <iframe
                src={playData}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="LatestVideoVideoSecRight_video"
              />
                {!isLocalhost && ytLoading && (
                  <div style={{ color: '#666', fontSize: 12, marginTop: 8 }}>Loading latest videos…</div>
                )}
              {!isLocalhost && ytError && (
                <div style={{ color: '#f87171', fontSize: 12, marginTop: 8 }}>{ytError}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LatestVideo;
